module.exports = __webpack_public_path__ + "img/no-data-video.5bc0d79d.svg";